import { Component, Input } from '@angular/core';
import { Option } from '@dch/products-business-logic';

@Component({
  selector: 'mprd-website-options',
  templateUrl: './website-options.component.html',
})
export class WebsiteOptionsComponent {
  @Input() options: Option[];
  @Input() selectedProduct: any;
  constructor() {}
}
